import { render, staticRenderFns } from "./report_composite.vue?vue&type=template&id=127e1938&scoped=true"
import script from "./report_composite.vue?vue&type=script&lang=js"
export * from "./report_composite.vue?vue&type=script&lang=js"
import style0 from "./report_composite.vue?vue&type=style&index=0&id=127e1938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e1938",
  null
  
)

export default component.exports